// console.log('From background_banner component!!!');

var secs = document.querySelectorAll('section');
var currentSection = 0;
var scrolldown = document.querySelector('#scrolldown');
if (scrolldown) {
  scrolldown.addEventListener('click', move);
}




function move(e) {
    e.preventDefault();
    var parentSection = e.target.parentNode.closest('section');
    var offsetBottom = parentSection.offsetTop + parentSection.offsetHeight;
    var headerHeight = 80;
    window.scroll({
        top: offsetBottom - headerHeight,
        left: 0,
        behavior: 'smooth'
      });
}